module.exports = "/_next/static/images/nhlIconActive@3x-3c70fc8f09e1a44bf11609930b155526.png";